/**
 * O som do aviso — `public/notification.mp3`, o mesmo para tudo que chega em
 * tempo real (`realtime.tsx`).
 *
 * Um `Audio` só, criado no primeiro uso e reaproveitado: dois avisos seguidos
 * reiniciam o som em vez de empilhar dois tocando por cima.
 *
 * `play()` pode ser recusado pelo navegador — a política de autoplay bloqueia
 * som antes do primeiro clique na página. A recusa é engolida de propósito: o
 * popup e o sino continuam dizendo que o aviso chegou, e o som é só o reforço.
 */
let audio: HTMLAudioElement | null = null;

export function playNotificationSound(): void {
  try {
    audio ??= new Audio('/notification.mp3');
    audio.currentTime = 0;
    void audio.play().catch(() => undefined);
  } catch {
    // ambiente sem `Audio` (teste, navegador sem suporte): segue sem som
  }
}
